import React from 'react';

const ResidentInfoSection = () => {
  return (
    <section className="py-8 sm:py-12 md:py-16" style={{ backgroundColor: '#db0058' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Three column content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Left column */}
          <div className="text-white">
            <p className="text-sm sm:text-base leading-relaxed mb-4">
              Once, businesses believed that simply gathering customer data was all they needed to do. But in today's world, precise information is identified, analysed and intensely applied to deliver true competitive advantage. In short, there's no more viable alternative than customer insight.
            </p>
            <p className="text-sm sm:text-base leading-relaxed">
              With RESIDENT, we're able to harness the power of data to deliver a bespoke process with added value throughout. We can provide the transformational steps to achieve optimum returns on investment — and meet your unique business requirements.
            </p>
          </div>
          
          {/* Middle column */}
          <div className="text-white">
            <p className="text-sm sm:text-base leading-relaxed">
              RESIDENT is unlike other products of its kind on the market as it has no data supplier hierarchy, which often compromises data integrity. RESIDENT is fully compliant with industry data regulations and fully permissioned for direct marketing purposes — bringing together the best available insurance, utility, lifestyle and transactional data sources, which are benchmarked on an annual basis to ensure data accuracy, quality, coverage and depth.
            </p>
          </div>
          
          {/* Right column */}
          <div className="text-white">
            <p className="text-sm sm:text-base leading-relaxed">
              With over 400 variables available, used for modelling and profiling, we can accurately identify prospects, deliver existing customer and prospect intelligence, enhance cross-sell and upsell campaigns and enable audience segmentation to aid proposition, incentive and channel led directives.
            </p>
          </div>
        </div>
        
        {/* Bottom tagline */}
        <div className="text-left mt-8 sm:mt-12">
          <h3 className="text-white text-xl sm:text-2xl md:text-3xl font-bold">
            52 million consumers; 400 attributes; endless possibilities.
          </h3>
        </div>
      </div>
    </section>
  );
};

export default ResidentInfoSection;